import { createContext, useEffect } from 'react';
import { VpsAlert } from '../../types/Types';
import VpsAlertHooks from './vpsAlert.hooks';

export const VpsAlertContext = createContext({
  vpsState: {
    vpsAlerts: [{} as VpsAlert],
    isLoading: false,
    errMessage: '',
  },
  createVpsAlert: (vpsAlert: VpsAlert) => {},
  updateVpsAlert: (vpsAlert: VpsAlert) => {},
  deleteVpsAlert: (vpsId: string) => {},
});

export function VpsAlertProvider(props: any) {
  const {
    state,
    findVpsAlerts,
    createVpsAlert,
    updateVpsAlert,
    deleteVpsAlert,
  } = VpsAlertHooks();

  useEffect(() => {
    findVpsAlerts();
  }, [findVpsAlerts]);

  return (
    <VpsAlertContext.Provider
      value={{
        vpsState: state,
        createVpsAlert,
        updateVpsAlert,
        deleteVpsAlert,
      }}
    >
      {props.children}
    </VpsAlertContext.Provider>
  );
}
